// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5480":"4fd9682167bd8a24","7678":"353c937bc96ad794","8194":"a8f042821ff15e74","8256":"cabacf471df3d57e"}[chunkId] + ".css";
};